const parseToAdminReservations = ({
	idReservaManual,
	nombre,
	detalles,
	finalizado,
	horario,
}) => {
	return {
		id: idReservaManual,
		name: nombre,
		details: detalles,
		schedule: {
			date: horario.fecha,
			timeStart: horario.horaInicio,
			timeEnd: horario.horaFin,
		},
		finalized: finalizado,
	};
};
const parseToPenalizeStudent = (sancion) => {
	return (
		sancion && {
			studentPenalizedId: sancion.idAlumnoSancionado,
			details: sancion.detalles,
			penalizeDays: sancion.diasSancion,
			reasonForPenalizeId: sancion.idMotivo,
			penalizeId: sancion.idBloqueo ? 1 : 0,
			blockId: sancion.idBloqueo || 0,
		}
	);
};
const parseToStudentReservation = ({
	codAlumno,
	nombreAlumno,
	idDetalleReserva,
	sancion,
	asistencia,
}) => {
	return {
		id: codAlumno,
		name: nombreAlumno,
		reservationDetailId: idDetalleReserva,
		penalty: parseToPenalizeStudent(sancion),
		attended: asistencia,
		saved: true,
		forTakeAttendance: false,
		forPenalize: false,
		forUpdatePenalty: false,
	};
};
const parseToReservations = ({
	idReservaServicio,
	estudiante,
	horario: { fecha, horaInicio, horaFin },
	finalizado,
}) => {
	return {
		id: idReservaServicio,
		student: {
			responsable: parseToStudentReservation(estudiante.responsable),
			others: estudiante.otros
				? estudiante.otros.map(parseToStudentReservation)
				: null,
		},
		schedule: {
			date: fecha,
			timeStart: horaInicio,
			timeEnd: horaFin,
		},
		finalized: finalizado,
	};
};
const parseToResource = ({
	recurso: {
		idServicioGeneral: id,
		nombre: name,
		idCampus: campusId,
		idBiblioteca: libraryId,
		idServicioPrestamo: resourceTypeId,
		detalles: details,
		activo: active,
		electronico,
		sala,
	},
	reservas,
	reservasManuales,
}) => ({
	resource: {
		id,
		name,
		campusId,
		libraryId,
		resourceTypeId,
		details: details || "",
		active,
		electronic: electronico && {
			brandId: electronico.idMarca,
			serial: electronico.serie || "",
			barcode: electronico.codigoBarras,
			model: electronico.modelo || "",
		},
		groupRoom: sala && {
			capacity: String(sala.capacidad),
			screenId: sala.idPantalla,
			groupRoomOutOfLibrary: Boolean(sala.ambiente),
			environment: sala.ambiente || "",
			address: sala.direccion || "",
		},
	},
	reservations: reservas.map(parseToReservations),
	adminReservations: reservasManuales.map(parseToAdminReservations),
});

const parseToElectronicResourceHistory = (obj) => {
	if (!obj) return {};
	const { codigoBarras, marca, modelo, serie } = obj;
	return {
		brand: marca,
		model: modelo,
		serial: serie,
		barcode: codigoBarras,
	};
};
const parseToGroupRoomResourceHistory = (obj) => {
	if (!obj) return {};
	const { ambiente, capacidad, direccion, pantalla } = obj;
	return {
		environment: ambiente,
		capacity: capacidad,
		address: direccion,
		screen: pantalla,
	};
};
const parseToResourceHistoryChanges = obj => {
	const {
		detalles,
		electronico,
		sala
	} = obj;
	let changes = {
		details: detalles,
	};
	if (electronico) {
		const {
			codigoBarras,
			marca,
			modelo,
			serie
		} = electronico;
		changes = {
			...changes,
			barcode: codigoBarras,
			brand: marca,
			model: modelo,
			serial: serie,
		};
	}
	else if (sala) {
		const {
			ambiente,
			capacidad,
			direccion,
			pantalla
		} = sala;
		changes = {
			...changes,
			environment: ambiente,
			capacity: capacidad,
			address: direccion,
			screen: pantalla
		};
	}
	return changes;
}

const helpers = {
	parseToResource,
	parseToStudentReservation,
	parseToResourceHistory: {
		electronicResource: parseToElectronicResourceHistory,
		groupRoomResource: parseToGroupRoomResourceHistory,
		changes: parseToResourceHistoryChanges
	}
};

export default helpers;
